import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { injectAuth } from "../api/axiosClient";

const aud = process.env.REACT_APP_AUDIENCE;

const useAuthBridge = () => {
  const { getAccessTokenSilently, logout } = useAuth0();

  useEffect(() => {
    injectAuth(
      async () =>
        await getAccessTokenSilently({
          authorizationParams: {
            audience: aud,
            scope: "openid profile email offline_access",
          },
          ignoreCache: true,
        }),
      logout
    );
  }, [getAccessTokenSilently, logout]);
};

export default useAuthBridge;
